"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fragment = fragment;
const mf_parser_1 = require("mf-parser");
const openchemlib_utils_1 = require("openchemlib-utils");
const fragmentAcyclicBonds_js_1 = require("./fragmentAcyclicBonds.js");
const fragmentRings_js_1 = require("./fragmentRings.js");
/**
 * This function fragment both acyclic and cyclic bonds of the molecule
 * @param {import('openchemlib').Molecule} molecule - The OCL molecule to be fragmented
 * @param {object} [options={}]
 * @param {boolean} [options.calculateHoseCodes=false] - calculating hose code for bonds is quite time consuming
 * @param {boolean} [options.cyclic=true] - calculate cyclic fragmentation
 * @param {boolean} [options.acyclic=true] - calculate acyclic fragmentation
 * @param {boolean} [options.full=true] - calculate the molecular formula of the full molecule
 * @returns {object} In-Silico fragmentation results
 */
function fragment(molecule, options = {}) {
    const { cyclic = true, acyclic = true, full = true, calculateHoseCodes = false, } = options;
    const parentIDCode = molecule.getIDCode();
    let molecularIon = full
        ? [
            {
                idCode: parentIDCode,
                parentIDCode,
                mfInfo: new mf_parser_1.MF((0, openchemlib_utils_1.getMF)(molecule).mf).getInfo(),
                fragmentType: 'molecule',
            },
        ]
        : [];
    let acyclicBonds = acyclic
        ? (0, fragmentAcyclicBonds_js_1.fragmentAcyclicBonds)(molecule, { calculateHoseCodes, parentIDCode })
        : [];
    let cyclicBonds = cyclic
        ? (0, fragmentRings_js_1.fragmentRings)(molecule, { calculateHoseCodes, parentIDCode })
        : [];
    let result = [...molecularIon, ...acyclicBonds, ...cyclicBonds];
    return result.sort((a, b) => a.mfInfo.monoisotopicMass - b.mfInfo.monoisotopicMass);
}
//# sourceMappingURL=fragment.js.map